import { type Money } from '../Types/Money';
import { StoreItem } from '../Types/StoreItem';
import { getApiInstance } from './Api';

const mapStoreItem = (storeItem: any): StoreItem => ({
  id: storeItem.id,
  name: storeItem.name,
  price: storeItem.price,
  imageUrl: storeItem.imageUrl,
  category: storeItem.category,
  bundleSize: storeItem.bundleSize,
});

export class WalletApi {
  async getBalance(currency?: string): Promise<Money | Money[]> {
    const endpoint = currency
      ? `/wallet/balance?currency=${currency}`
      : '/wallet/balance';
    const response = await getApiInstance().get<Money | Money[]>(endpoint);
    return response.data;
  }

  async buyRobux(amount: number, robloxUsername: string) {
    const robuxItem = await this.getRobuxItem();
    return this.buyStoreItem(robuxItem.id, amount / robuxItem.bundleSize, {
      robloxUsername: robloxUsername,
    });
  }

  private async getRobuxItem(): Promise<StoreItem> {
    const response = await getApiInstance().get(`/wallet/store`);
    const robuxStoreItem = response.data.find(
      (item: any) => item.name === 'Robux',
    );
    return mapStoreItem(robuxStoreItem);
  }

  private async buyStoreItem(
    itemId: string,
    amount: number,
    metadata?: Record<string, any>,
  ) {
    const response = await getApiInstance().post(`/wallet/buy`, {
      itemId,
      amount,
      metadata,
    });
    return response.data;
  }
}
